import { GOAL_PROGRESSES } from 'constants/ProjectConstants';

const EMPLOYEE_UPDATE_DATA = 'EMPLOYEE_FILTER_UPDATE_DATA';
const TEAMS_UPDATE_DATA = 'EMPLOYEE_FILTER_UPDATE_DATA';
const PRIMARY_POD_UPDATE_DATA = 'PRIMARY_POD_UPDATE_DATA';
const TASK_TYPE_UPDATE_DATA = 'TASK_TYPE_UPDATE_DATA';
const GOAL_PROGRESS_UPDATE_DATA = 'GOAL_PROGRESS_UPDATE_DATA';
const TASK_TAGS_UPDATE = 'TASK_TAGS_UPDATE';

export function employeesReducer(state = [], action) {
  switch (action.type) {
    case EMPLOYEE_UPDATE_DATA:
      return action.data;
    default:
      return state;
  }
}

export function teamsReducer(state = [], action) {
  switch (action.type) {
    case TEAMS_UPDATE_DATA:
      return action.data;
    default:
      return state;
  }
}

export function primaryPodsReducer(state = [], action) {
  switch (action.type) {
    case PRIMARY_POD_UPDATE_DATA:
      return action.data;
    default:
      return state;
  }
}

export function taskTypesReducer(state = [], action) {
  switch (action.type) {
    case TASK_TYPE_UPDATE_DATA:
      return action.data;
    default:
      return state;
  }
}

export function goalProgressReducer(state = GOAL_PROGRESSES, action) {
  switch (action.type) {
    case GOAL_PROGRESS_UPDATE_DATA:
      return action.data;
    default:
      return state;
  }
}

export function taskTagsReducer(state = [], action) {
  switch (action.type) {
    case TASK_TAGS_UPDATE:
      return { ...action.data };
    default:
      return state;
  }
}
